import {
    Component,
    ElementRef,
    forwardRef,
    Inject,
    Input,
    OnInit,
    Optional,
    Self,
    ViewChild,
} from '@angular/core';
import {
    ControlContainer,
    ControlValueAccessor,
    FormControl,
    FormGroup,
    FormGroupDirective,
    NgControl,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { IFileUpload } from '../../interfaces/file-upload.interface';
import { INPUT_FILE_CONFIG } from './input-file.config';
import { InputFileService } from './input-file.service';

@Component({
    selector: 'roblex-input-file',
    templateUrl: './input-file.component.html',
    styleUrls: ['./input-file.component.scss'],
    providers: [
        InputFileService,
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => InputFileComponent),
        },
    ],
})
export class InputFileComponent implements OnInit, ControlValueAccessor {
    /**
     * Input  of input field component
     */
    @Input() disabled: boolean = false;
    /**
     * Input  of input form field component
     */
    @Input() formControlName: string;
    /**
     * Input  of input file component
     */
    @Input() accept = 'image/x-png,image/jpeg';
    /**
     * View child of input file component
     */
    @ViewChild('inputFile') inputFile: ElementRef;
    /**
     * Determines whether touched callback on
     */
    onTouchedCallback: () => void;
    /**
     * Propagate change of input field component
     */
    onChangeCallback = (_: any) => {};
    /**
     * Value  of input field component
     */
    _value = '';
    /**
     * File upload of input file component
     */
    fileUpload: IFileUpload;
    /**
     * Gets value
     */
    get value() {
        return this._value;
    }
    /**
     * Gets form
     */
    get form(): FormGroup {
        return this.controlContainer?.formDirective
            ? (this.controlContainer?.formDirective as FormGroupDirective).form
            : null;
    }
    /**
     * Gets control
     */
    get control(): FormControl {
        return this.form.controls[this.formControlName] as FormControl;
    }
    /**
     * Gets class valid
     */
    get classValid() {
        const classList = {};

        classList['input-file-invalid'] =
            this.control?.touched && this.control?.invalid;

        return classList;
    }
    /**
     * Sets value
     */
    set value(val) {
        this._value = val;
        this.onChangeCallback(this._value);
    }
    /**
     * Creates an instance of input file component.
     * @param inputFileService InputFileService
     */
    constructor(
        private inputFileService: InputFileService,
        private controlContainer: ControlContainer,
        @Inject(INPUT_FILE_CONFIG) public inputConfig: any
    ) {
        //
    }
    /**
     * on init
     */
    ngOnInit(): void {
        //
    }
    /**
     * Determines whether change file on
     * @param event any
     */
    onChangeFile(event: any): void {
        if (!event.target.files[0]) {
            return;
        }
        this.inputFileService
            .upload(event.target.files[0])
            .subscribe((res: IFileUpload) => {
                this.fileUpload = res;
                this.writeValue(res.filename);
            });
    }
    /**
     * Determines whether click remove on
     */
    onClickRemove(): void {
        this.fileUpload = null;
        this.control.reset();
    }
    /**
     * Writes value
     * @param value any
     */
    writeValue(value: any): void {
        this.value = value;
        this.onChangeCallback(this.value);
    }
    /**
     * Registers on change
     * @param fn any
     */
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }
    /**
     * Registers on touched
     * @param fn any
     */
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
    /**
     * Sets disabled state
     * @param isDisabled boolean
     */
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
